import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import AboutHero from './components/AboutHero';
import AboutStats from './components/AboutStats';
import AboutMission from './components/AboutMission';
import AboutValues from './components/AboutValues';
import AboutStory from './components/AboutStory';
import AboutCTA from './components/AboutCTA';

export default function About() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main>
        <AboutHero />
        <AboutStats />
        <AboutMission />
        <AboutValues />
        <AboutStory />
        <AboutCTA />
      </main>
      <Footer />
    </div>
  );
}